module.exports = __webpack_public_path__ + "static/linkedlist-2.8-285171828cddc3f510eb1a0fddeed821.png";